// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"faq-item-module__expandIcon___xzlT6","question":"faq-item-module__question___a2JI-","answer":"faq-item-module__answer___kPiqU"};